var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer d-flex justify-content-center"},[_c('div',{staticClass:"copyright"},[_vm._v(" Copyright © "+_vm._s(_vm.year)+" "),_c('a',{staticClass:"font-weight-bold",attrs:{"href":"https://ai.gcbridge.ch/","target":"_blank","rel":"noopener"}},[_vm._v("gcbridge.ch")]),_vm._v(" . All rights reserved ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }